import { useQueryClient } from 'react-query';
import { useCallback } from 'react';
import { CURRENT_USER_PERMISSIONS_QUERY_KEY } from './queryKey';

export const useInvalidatePermissionQuery = (): (() => Promise<void>) => {
  const queryClient = useQueryClient();

  return useCallback(
    () => queryClient.invalidateQueries(CURRENT_USER_PERMISSIONS_QUERY_KEY),
    [queryClient],
  );
};
